import React from "react";
import { Radio } from "@rmwc/radio";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";

const BracingSection = ({ title, options, selectedValue, actionType, paramValue, priceKey, type, const_var, elementPrice, extraItemsAction, returnBracingPrice }) => {
	if (!options?.length) return null;

	return (
		<div className="col-6">
			<div className="form-group">
				<label className="control-label">{title}</label>

				{options.map((option, index) => (
					<div className="row" key={index}>
						<div className={"col-12" + (option.is_default === "included" && options.length === 1 ? " disabled" : "")}>
							<div className="radio-group">
								<Radio
									label={option.sheet_label}
									value={option.sheet_name}
									name={`${type}-bracing-type`}
									checked={option.sheet_name === selectedValue}
									onChange={(e) => extraItemsAction(e.target.value, actionType)}
								/>
							</div>

							{option.sheet_name !== "none" && option.sheet_name === selectedValue && (
								<>
									{const_var.post_data.building !== undefined && const_var.loginSession == true ? (
										<div className="price-box">
											<EditPriceItem is_disabled={paramValue === true ? "false" : "true"} jsonObj="extraitems" jsonObjValue={paramValue} jsonObjKey={priceKey} />
										</div>
									) : (
										<div className="price-box-type-2">{const_var.hide_price_calculation != 1 && const_var.loginSession == false && returnBracingPrice(elementPrice, type)}</div>
									)}
								</>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

const BracingSetting = ({ params, const_var, elementPrice, extraItemsAction }) => {
	const sideBracing = const_var?.a_p_d_a?.side_cross_bracing || [];

	const endBracing = const_var?.a_p_d_a?.end_cross_bracing || [];

	if (sideBracing.length === 0 && endBracing.length === 0) {
		return null;
	}
	const returnBracingPrice = (data, isFor) => {
		if (!data) return null;

		const bracingName = isFor == "side" ? "Side Cross Bracing" : isFor == "end" ? "End Cross Bracing" : null;

		if (!bracingName) return null;

		const bracingObject = Object.keys(data).find((obj) => data[obj]?.other_item_name == bracingName);

		return bracingObject && data[bracingObject]?.item_price ? (
			<div className="price-box-type-2">
				<CurrencyFormat value={data[bracingObject].item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
			</div>
		) : null;
	};
    
	return (
		<div className="row">
			<div className="col-12 control-label">Types of Bracing :</div>

			<BracingSection
				title="Side"
				options={sideBracing}
				selectedValue={const_var.selected_scbracing}
				actionType="scbracing"
				paramValue={params.p_s_c_b}
				priceKey="Side Cross Bracing"
				type="side"
				const_var={const_var}
				elementPrice={elementPrice}
				extraItemsAction={extraItemsAction}
				returnBracingPrice={returnBracingPrice}
			/>

			<BracingSection
				title="End"
				options={endBracing}
				selectedValue={const_var.selected_ecbracing}
				actionType="ecbracing"
				paramValue={params.p_e_c_b}
				priceKey="End Cross Bracing"
				type="end"
				const_var={const_var}
				elementPrice={elementPrice}
				extraItemsAction={extraItemsAction}
				returnBracingPrice={returnBracingPrice}
			/>
		</div>
	);
};

export default BracingSetting;
